import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  TextField,
  Button,
  Container,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import {
  Payment as PaymentIcon,
  Home as HomeIcon,
  CalendarToday as CalendarTodayIcon,
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const baseUrl = process.env.REACT_APP_APP_URL;

const AdminPaiment = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [status, setStatus] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [userId, setUserId] = useState(""); // User who is making the payment
  const [users, setUsers] = useState([]); // List of users to select from
  const [searchTerm, setSearchTerm] = useState(""); // State for search input
  const token = localStorage.getItem("CC_Token");

  useEffect(() => {
    // Fetch users from the API
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/users/members`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.members)) {
          setUsers(response.data.members); // Set the list of users under the 'members' key
        } else {
          console.error("Invalid response format: users data is not an array");
          setUsers([]); // Set empty array if the response isn't correct
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Erreur lors de la récupération des utilisateurs.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    };
    fetchUsers();
  }, [token]);

  const handlePaymentSubmit = async () => {
    try {
      const data = {
        user_id: userId,
        invoice_number: invoiceNumber,
        amount: amount,
        due_date: date,
        status: status,
      };

      const response = await axios.post(`${baseUrl}/api/invoices`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Paiement enregistré avec succès!", {
        position: "top-right",
        autoClose: 3000,
      });

      setAmount("");
      setDate("");
      setStatus("");
      setInvoiceNumber("");
      setUserId(""); // Reset user ID if needed
    } catch (error) {
      console.error("Error submitting payment:", error);
      toast.error("Une erreur est survenue. Veuillez réessayer.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleNavigateToNotifications = () => {
    navigate("/AdminGetNotifs");
  };

  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000); // Redirect after toast
  };

  const filteredUsers = users.filter((user) =>
    `${user.name} (${user.email})`.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleProfile = () => {
    navigate("/ProfileAdmin");
  };

  return (
    <div className="app">
      {/* Toast Container */}
      <ToastContainer />

      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ padding: "1rem", backgroundColor: "#f8f8f8", borderRadius: "8px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)" }}>
  <Typography
    variant="h4"
    sx={{
      fontWeight: "600",
      textAlign: "center",
      color: "#333",
      marginBottom: "1.5rem",
    }}
  >
    Paiement Client
  </Typography>

  {/* Formulaire de Paiement */}
  <Grid container spacing={2} justifyContent="center">
    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="Rechercher un utilisateur"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginBottom: "1rem",  // Diminuer l'espace entre les champs
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
       <InputLabel>Utilisateur</InputLabel>
  <Select
    value={userId}
    onChange={(e) => setUserId(e.target.value)}
    label="Utilisateur"
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: "5px",
      padding: "6px 10px",  // Réduire le padding pour une taille plus petite
      fontSize: "0.875rem", // Réduire la taille de la police
      height: "60px", // Réduire la hauteur du ComboBox
    }}
    MenuProps={{
      PaperProps: {
        style: {
          maxHeight: 200,  // Limiter la hauteur du menu déroulant
          width: '100%',    // Garder la largeur du menu égale à celle du ComboBox
        },
      },
    }}
  >
    {filteredUsers.length > 0 ? (
      filteredUsers.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          {`${user.name} (${user.email})`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>Aucun utilisateur trouvé</MenuItem>
    )}
  </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="N Facture / Description" 
        variant="outlined"
        fullWidth
        value={invoiceNumber}
        onChange={(e) => setInvoiceNumber(e.target.value)}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginBottom: "1rem",  // Diminuer l'espace entre les champs
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="Montant"
        variant="outlined"
        fullWidth
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginBottom: "1rem",  // Diminuer l'espace entre les champs
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <TextField
        label="Date d'échéance"
        type="date"
        variant="outlined"
        fullWidth
        value={date}
        onChange={(e) => setDate(e.target.value)}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginBottom: "1rem",  // Diminuer l'espace entre les champs
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <FormControl fullWidth sx={{ marginBottom: "0.5rem" }}>
        <InputLabel>Statut</InputLabel>
        <Select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          label="Statut"
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            padding: "8px 12px",
          }}
        >
          <MenuItem value="Payé">Payé</MenuItem>
          <MenuItem value="À payer">À payer</MenuItem>
          <MenuItem value="Acompte">Acompte</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<PaymentIcon />}
        onClick={handlePaymentSubmit}
        fullWidth
        sx={{
          padding: "0.75rem",
          fontSize: "1rem",  // Diminuer la taille du texte du bouton
          backgroundColor: "#004080",
          borderRadius: "5px",
        }}
      >
        Enregistrer Paiement
      </Button>
    </Grid>
  </Grid>
</Box>


      {/* Footer */}
      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation
          sx={{
            backgroundColor: "#003366",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <BottomNavigationAction
            label="Calendrier"
            icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminChrono")}
          />
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/Admin")}
          />
          <BottomNavigationAction
            label="Paiement"
            icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
            sx={{ color: "#ffffff", minWidth: "auto" }}
            onClick={() => navigate("/AdminPaiment")}
          />
        </BottomNavigation>
      </Box>
    </div>
  );
};

export default AdminPaiment;
